// this is an autogenerated file from DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/SendCommunication/EmailTemplateEditor/Content/Preview/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_EditAutomation_EventActions_Content_EventAction_Content_Content_Content_SendCommunication_EmailTemplateEditor_Content_Preview_Content(
  $to: String!
  $content: String!
  $from: String!
  $subject: String!
  $advanced_editor: Boolean!
) {
  comms_send_preview_email(
    to: $to
    content: $content
    from: $from
    subject: $subject
    advanced_editor: $advanced_editor
  ) {
    ok
  }
}

`